import { render, staticRenderFns } from "./PortletOwasp.vue?vue&type=template&id=e956de16"
import script from "./PortletOwasp.vue?vue&type=script&lang=js"
export * from "./PortletOwasp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports